<template>
  <div v-show='cpntMostrar' class="rf-toogles--2" :class='cpntClassDivField'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <label v-if="cpntNome !== ''" :for='cpntId' :class='"has-" + cpntMensagemTipo'>
        <span v-html='cpntNome'></span>

        <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'
        ></RF-Explica>
      </label>
      <div :id='cpntId' class="rf-toogles--2">
        <template>
          <button v-for="(button, index) in cpntOptions" :key="index"
            :style="'width: ' + (100 / cpntOptions.length) + '%;'"
            :tabIndex="cpntTabIndex" 
            class="btn btn-default btn-sm" 
            :disabled="!button.hasOwnProperty('disabled') ? false : button.disabled"
            :class="'rf-toogles-' + (cpntValue === button[cpntKeyValue] ? true : 'false rf-button-disabled')" 

            @click="togglesOnClick(index)">
            <span v-for='(key, keyIndex) in cpntKeyMostra' :key="keyIndex">
              <span v-if='button.hasOwnProperty(key)' v-html='button[key]'></span>
              <span v-else v-html='key'></span>
            </span>
          </button>
        </template>
      </div>
      <div style="clear: both;"></div>
      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
    </template>
  </div>
</template>

<style scoped>
  .rf-toogles--2 {
    display: inline-block;
    margin: 0px 5px;
  }
    .rf-toogles--2 > label {
      color: var(--color-base-02);
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      margin: 0px;
      margin-bottom: 2px;
      white-space: nowrap;
    }
    .rf-toogles--2 > div  {
      width: 100%;
    }
      .rf-toogles--2 > div > button:disabled {
        background-color: #e6e6e6 !important;
        cursor: no-drop !important;
      }
      .rf-toogles--2 > div > button {
        float: left;
        /* width: 50%; */
        text-shadow: none;
      }
      .rf-toogles--2 > div > button.rf-button-disabled {
        cursor: pointer;
      }
        .rf-toogles--2 > div > button:first-child {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          border-right: none;
        }

        .rf-toogles--2 > div > button:not(:first-child):not(:last-child) {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          /* border-right: none; */

          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          /* border-left: none; */
        }

        .rf-toogles--2 > div > button:last-child {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          border-left: none;
        }

      .rf-toogles--2 > div > .rf-toogles-true {
        background-color: #17a2b8 !important;
        color: #fff;
      }
</style>
 
<script>
  export default {
    name: 'RF-Toggles--2',
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntOptions: {
        type: Array,
        required: true
      },
      cpntKeyValue: {
        type: String,
        required: true
      },
      cpntKeyMostra: {
        type: Array,
        required: true
      },

      cpntOnChange: {
        required: true,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        status: '',
        time: ''
      }
    },
    mounted: function () {
      this.togglesIniciar()
    },
    methods: {
      togglesIniciar: function () {
        var self = this

        // SETA O STATUS DO FORMULARIO
        self.status = 'carregando'

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()

        // SETA O STATUS DO FORMULARIO
        self.status = ''

        // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
        self.time = new Date().getTime()
      },
      // togglesVerificaMarcado: function (callback = null) {
      //   if (callback !== null) {
      //     callback()
      //   }
      // },
      togglesOnClick: function (index) {
        if (!this.cpntOptions[index].hasOwnProperty('disabled') || this.cpntOptions[index].disabled === false) {
          this.cpntOnChange(this.cpntOptions[index][this.cpntKeyValue], this.cpntId)
        }
      }
      // iniciarComponent: function () {
      //   var self = this

      //   self.value = self.cpntValue

      //   setTimeout(function () {
      //     $('#' + self.cpntId).bootstrapToggle({
      //       width: self.cpntWidth
      //     }).change(function ($event) {
      //       self.value = $('#' + self.cpntId).prop('checked')

      //       if (self.value !== self.cpntValue) {
      //         // EMITE UM EVENTO PARA ATUALIZAR O COMPONENT PAI
      //         self.cpntOnChange(self.value, self.cpntId)
      //       }
      //     })
      //   }, 300)
      // }
    },
    watch: {
      // 'cpntValue': function () {
      //   this.value = this.cpntValue

      //   if (this.cpntValue === true) {
      //     $('#' + this.cpntId).bootstrapToggle('on')
      //   } else if (this.cpntValue === false) {
      //     $('#' + this.cpntId).bootstrapToggle('off')
      //   }
      // }
    }
  }
</script>
